export enum QueryParameter {
    REDIRECT_TO_FILM_PAGE = 'rt',
    WATCH = 'watch',
    SEASON_NUMBER = 'season',
    EPISODE_NUMBER = 'episode',
    WELCOME_PAGE = 'welcome',
    RETURN_PATH = 'retpath',
    CONTINUE_WATCHING = 'continueWatching',
    PROMO = 'promo',
    PAYMENT_FROM_SELECTION_ID = 'payment_from_selection_id',
    PAYMENT_FROM = 'payment_from',
    PLAYER_VERSION = 'playerVersion',
    /** @see OTT-15611 */
    X_FORWARDED_FOR = 'xForwardedFor',
    /** @see OTT-14382 */
    TEST_ID = 'testId',
    /** @see OTT-13484 */
    FAVOURITE_FILM_ID = 'favourite_film_id',
    /** @see OTT-19921 */
    KEEP_SHOWING_PLAYER_CONTROLS = 'keepShowingPlayerControls',
    /** @see OTT-22562 */
    CONTENT_TAB = 'content_tab',
    /** @see OTT-25060 */
    CHANNEL_CATEGORY_TAB = 'channelCategoryTab',
    /** @see OTT-28279 */
    OPENED_CHANNEL_ID = 'openedChannelId',
    IS_EDITING = 'isEditing',
    SELECTION_WINDOW_ID = 'selectionWindowId',
    PLAYING_CONTENT_ID = 'playingContentId',
    PAYWALL_OFFER_TAB = 'paywallOfferTab',
    /** @see SAFTWEB-418 */
    REQUEST_FOR_SUBSCRIPTIONS_TERMS = 'requestForSubscriptionsTerms',
    SPORT_EVENT_ID = 'sportEventId',
}
